import { Buffer } from 'buffer'
;(globalThis as unknown as Record<string, unknown>).Buffer = Buffer

import Phaser from 'phaser'
import BootScene from './scenes/BootScene'
import HubScene from './scenes/HubScene'
import DrillScene from './scenes/DrillScene'
import { getCluster } from './chain/connection'
import { setLocalKeypair } from './chain/wallet'

async function boot(): Promise<void> {
  // In localnet mode, load the dev keypair for signing transactions
  if (getCluster() === 'localnet') {
    try {
      const resp = await fetch('/dev-keypair.json')
      const bytes: number[] = await resp.json()
      setLocalKeypair(new Uint8Array(bytes))
      console.log('[chain] Local dev keypair loaded')
    } catch (e) {
      console.warn('[chain] Could not load dev keypair:', e)
    }
  }

  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    width: 720,
    height: 1280,
    parent: 'game-container',
    backgroundColor: '#1a1a2e',
    pixelArt: true,
    roundPixels: true,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, HubScene, DrillScene],
  }

  new Phaser.Game(config)
}

boot()
